<template>
    <v-form ref="form">
        <v-row> 
            <v-col>
                <v-autocomplete
                    label="Item"
                    dense
                    hide-details="auto"
                    outlined
                    :rules="[isRequired]"
                    v-model="form.item_id"
                    @update:search-input="itemSearch"
                    :items="items"
                    item-value="id"
                    item-text="name"
                    clearable
                    :disabled="edit"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    label="Measure Unit"
                    dense
                    hide-details="auto"
                    outlined
                    :rules="[isRequired]"
                    v-model="form.measure_unit_id"
                    @update:search-input="measureUnitSearch"
                    :items="measureUnits"
                    item-value="id"
                    item-text="name"
                    clearable
                    :disabled="edit"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Conversion"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="[isRequired, isNumeric]"
                    v-model="form.conversion"
                    :prefix="measureUnit ? `${1} ${measureUnit.name} = ` : null"
                    :suffix="item && item.measure_unit ? item.measure_unit.name : null"
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired, isNumeric } from './../../utils/validations'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "ItemMeasureUnitForm",
    props: {
        value: Object,
        edit: Boolean,
        item: Object
    },
    data() {
        return {
            form: {
                item_id: null,
                measure_unit_id: null,
                conversion: null
            }
        }
    },
    computed: {
        ...mapGetters({
            items: 'stock/item/search/data',
            measureUnits: "warehouse/measureUnit/search/data"
        }),
        measureUnit() {
            return this.measureUnits.find(each => each.id == this.form.measure_unit_id);
        },
        // allowedMeasureUnits() {
        //     if(!this.item) return [];
        //     if(!this.item.measure_unit) return [];
        //     return this.measureUnits.filter(each => each.id != this.item.measure_unit.id)
        // }
    },
    methods: {
        isRequired,
        isNumeric,
        ...mapActions({
            itemSearch: "stock/item/search/get",
            measureUnitSearch: "warehouse/measureUnit/search/get"

        }),
        validate() {
            return this.$refs.form.validate()
        }
    },  
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    mounted  () {
        if(this.value) {
            this.form = {...this.form, ...this.value}
        }    
    }
}
</script>

<style>

</style>